import { range, timer } from "rxjs";
import {
  map,
  delayWhen,
  combineLatestAll,
  concatAll,
  exhaustAll,
  mergeAll,
  switchAll
} from "rxjs/operators";
import { Examples } from "./index";

export const flatternExamples = {
  combineLatestAll: {
    label: "combineLatestAll",
    inputs: [
      [{ t: 0, c: "A" }, { t: 10, c: "B" }, { t: 20, c: "C" }, 25],
      [{ t: 0, c: "D" }, { t: 10, c: "E" }, { t: 20, c: "F" }, 25]
    ],
    apply: function (inputs, scheduler) {
      const highOrder$ = range(0, inputs.length).pipe(
        delayWhen((i) => timer(i * 20, scheduler)),
        map((i) => inputs[i])
      );
      return highOrder$.pipe(
        combineLatestAll(),
        map(([x, y]) => `[${x.content},${y.content}]`)
      );
    }
  },

  concatAll: {
    label: "concatAll",
    inputs: [
      [{ t: 0, c: "A" }, { t: 10, c: "B" }, { t: 20, c: "C" }, 25],
      [{ t: 0, c: "D" }, { t: 10, c: "E" }, { t: 20, c: "F" }, 25],
      [{ t: 0, c: "G" }, { t: 10, c: "H" }, { t: 20, c: "I" }, 25]
    ],
    apply: function (inputs, scheduler) {
      const highOrder$ = range(0, inputs.length).pipe(
        delayWhen((i) => timer(i * 20, scheduler)),
        map((i) => inputs[i])
      );
      return highOrder$.pipe(concatAll());
    }
  },

  exhaustAll: {
    label: "exhaustAll",
    inputs: [
      [{ t: 0, c: "A" }, { t: 10, c: "B" }, { t: 20, c: "C" }, 25],
      [{ t: 0, c: "D" }, { t: 10, c: "E" }, { t: 20, c: "F" }, 25],
      [{ t: 0, c: "G" }, { t: 10, c: "H" }, { t: 20, c: "I" }, 25]
    ],
    apply: function (inputs, scheduler) {
      const highOrder$ = range(0, inputs.length).pipe(
        delayWhen((i) => timer(i * 20, scheduler)),
        map((i) => inputs[i])
      );
      return highOrder$.pipe(exhaustAll());
    }
  },

  mergeAll: {
    label: "mergeAll",
    inputs: [
      [{ t: 0, c: "A" }, { t: 5, c: "B" }, { t: 15, c: "C" }, 25],
      [{ t: 0, c: "D" }, { t: 8, c: "E" }, { t: 18, c: "F" }, 25],
      [{ t: 0, c: "G" }, { t: 10, c: "H" }, { t: 20, c: "I" }, 25]
    ],
    apply: function (inputs, scheduler) {
      const highOrder$ = range(0, inputs.length).pipe(
        delayWhen((i) => timer(i * 20, scheduler)),
        map((i) => inputs[i])
      );
      return highOrder$.pipe(mergeAll());
    }
  },

  switchAll: {
    label: "switchAll",
    inputs: [
      [{ t: 0, c: "A" }, { t: 10, c: "B" }, { t: 20, c: "C" }, 25],
      [{ t: 0, c: "D" }, { t: 10, c: "E" }, { t: 20, c: "F" }, 25],
      [{ t: 0, c: "G" }, { t: 10, c: "H" }, { t: 20, c: "I" }, 25]
    ],
    apply: function (inputs, scheduler) {
      const highOrder$ = range(0, inputs.length).pipe(
        delayWhen((i) => timer(i * 20, scheduler)),
        map((i) => inputs[i])
      );
      return highOrder$.pipe(switchAll());
    }
  }
} as Examples;
